<template>
  <ion-list v-if="resources.data.length > 0">
    <ion-item
      v-for="item in resources.data"
      :key="item.id"
      :ref="`items-${item.id}`"
      class="hydrated link"
    >
      <ion-label @click="openPopover(item, $event)">
        <h2>
          {{ item.name }} <ion-note>Class {{ item.standard.name }}</ion-note>
        </h2>
        <ion-note>{{ item.subject_group.name }}</ion-note>
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-list v-else>
    <ion-list-header>
      <p>No subjects found</p>
    </ion-list-header>
  </ion-list>
  <ion-modal
    :is-open="updateModalState"
    @didDismiss="setUpdateModalState(false)"
  >
    <base-modal title="Update subject" @closeModal="setUpdateModalState(false)">
      <update-subject
        @closeModal="setUpdateModalState(false)"
        :resource="resourceToUpdate"
      ></update-subject>
    </base-modal>
  </ion-modal>

  <ion-popover
    :is-open="popoverState"
    :event="popoverEvent"
    @didDismiss="setPopoverState(false)"
  >
    <base-popover
      @closePopover="setPopoverState(false)"
      :title="`
        ${selectedResource.name} (Class ${selectedResource.standard.name})`"
    >
      <ion-item
        button
        :router-link="{
          name: 'subject.teacher',
          params: {
            subject: selectedResource.id,
            title: `${selectedResource.name} - Class ${selectedResource.standard.name}`,
          },
        }"
        @click="setPopoverState(false)"
        >Teachers</ion-item
      >
      <ion-item
        button
        :router-link="{
          name: 'subject.student',
          params: {
            subject: selectedResource.id,
            title: `${selectedResource.name} - Class ${selectedResource.standard.name}`,
          },
        }"
        @click="setPopoverState(false)"
        >Students</ion-item
      >
      <ion-item
        button
        :router-link="{
          name: 'subject.chapter',
          params: {
            subject: selectedResource.id,
            title: `${selectedResource.name} - Class ${selectedResource.standard.name}`,
          },
        }"
        @click="setPopoverState(false)"
        >Chapters</ion-item
      >
      <ion-item button @click="setResourceToUpdate(selectedResource.id)"
        >Edit</ion-item
      >
      <ion-item
        button
        @click="
          confirmDelete({
            id: selectedResource.id,
            name: selectedResource.name,
          })
        "
        >Delete</ion-item
      >
    </base-popover>
  </ion-popover>
</template>
<script>
import BaseModal from "../../../Base/BaseModal";
import BasePopover from "../../../Base/BasePopover.vue";
import UpdateSubject from "../Subject/UpdateSubject.vue";
import {
  IonList,
  IonListHeader,
  IonLabel,
  IonNote,
  IonItem,
  IonModal,
  IonPopover,
  alertController,
} from "@ionic/vue";

export default {
  props: {
    resources: {
      type: Object,
      required: true,
    },
  },

  components: {
    IonList,
    IonListHeader,
    IonLabel,
    IonNote,
    IonItem,
    IonModal,
    IonPopover,
    BaseModal,
    BasePopover,
    UpdateSubject,
  },
  data() {
    return {
      updateModalState: false,

      popoverState: false,
      popoverEvent: null,
      selectedResource: null,

      resourceToUpdate: {
        id: null,
        name: null,
      },

      xhrError: {
        header: null,
        description: null,
      },
    };
  },
  methods: {
    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    setErrorResponse(error) {
      if (error.response) {
        this.xhrError.header = error.response.data.header;
        this.xhrError.message = error.response.data.message;
      } else if (error.request) {
        this.xhrError.header = error.message || error.request;
        this.xhrError.message = "Please check your connection and try again";
      } else {
        this.xhrError.header = error.message;
        this.xhrError.message = "Something went wrong. Try again later";
      }
    },

    async confirmDelete(resource) {
      this.setPopoverState(false);
      const header = `Delete subject ${resource.name} ?`;
      const message = "This action cannot be undone.";
      const buttons = [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: "Okay",
          handler: () => {
            this.delete(resource.id);
          },
        },
      ];
      const alertDialog = await this.alerter(header, message, buttons);

      alertDialog.present();
    },

    async delete(data) {
      try {
        await this.$store.dispatch("subject/deleteResource", data);
      } catch (error) {
        this.setErrorResponse(error);
        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );
        alertDialog.present();
      }
    },

    openPopover(resource, ev) {
      this.popoverEvent = ev;
      this.setSelectedResource(resource);
      this.setPopoverState(true);
    },

    setPopoverState(state) {
      this.popoverState = state;
    },

    setSelectedResource(resource) {
      this.selectedResource = resource;
    },

    setUpdateModalState(state) {
      this.updateModalState = state;
      if (state == false) {
        this.setPopoverState(false);
      }
    },

    setResourceToUpdate(id) {
      const resource = this.resources.data.find(
        (resource) => resource.id === id
      );
      this.resourceToUpdate = resource;
      this.setUpdateModalState(true);
    },
  },
};
</script>
